<template>
  <div class="app-container">
    <el-card class="box-card">
      <!-- 搜索-->
      <dynamic-search
        :data="tableFilterList(queryFields)"
        @search="dataTableSearch"
      >
        <template v-slot:next>
          <el-button v-if="!isAdmin" icon="el-icon-plus" @click="add()">新增</el-button>
           <el-button icon="el-icon-upload2" @click="downloadExcel()">导出</el-button>
        </template>
      </dynamic-search>
      <edit-data-table
        :head="tableHead"
        :data="list"
        :editable="false"
        :total="total"
        :offset="offset"
        :page="page"
        :loading="loading"
        stripe
        border
        @handlePageChange="dataTablePageChange"
        @handleSizeChange="dataTableSizeChange"
      >
        <template #toolbar="scope">
          <el-button
            type="text"
            icon="el-icon-view"
            style="color:#4084B7;"
            @click="showById(scope.row)"
          />
          <el-button type="text" v-if="statusEdit(scope.row.billState)" icon="el-icon-edit" style="color:#4084B7;" @click="edit(scope.row)"></el-button>
          <!-- <el-popover
            v-if="statusUnAudit(scope.row.billState)"
            :ref="'audit'+scope.row.billState"
            placement="top"
            width="180"
          >
            <p>确定反审核该单据吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="$refs['audit'+scope.row.billState].doClose()">取消</el-button>
              <el-button type="primary" size="mini" @click="reject(scope.row, 5)">确定</el-button>
            </div>
            <el-button type="text" size="mini" icon="el-icon-circle-close" slot="reference"></el-button>
          </el-popover> -->
          <!-- <el-popover
            :ref="`audit${scope.row.id}`"
            placement="top"
            width="220"
            v-if="scope.row.billState === 2"
          >
            <p>确定退回该借用单据吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="$refs[`audit${scope.row.id}`].doClose()">取消</el-button>
              <el-button type="primary" size="mini" @click="reject(scope.row)">退回</el-button>
            </div>
            <el-button type="text" size="mini" icon="el-icon-back" slot="reference"></el-button>
          </el-popover> -->
          <el-popover :ref="scope.row.id" placement="top" width="180" v-if="statusEdit(scope.row.billState)">
            <p>确定删除本条数据吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="$refs[scope.row.id].doClose()">取消</el-button>
              <el-button
                :loading="loading"
                type="primary"
                size="mini"
                @click="del(scope.row.id)"
              >确定</el-button>
            </div>
            <el-button
              type="text"
              size="mini"
              icon="el-icon-delete"
              slot="reference"
            ></el-button>
          </el-popover>
        </template>
      </edit-data-table>
    </el-card>
  </div>
</template>

<script>
import "@/components/EditDataTable";
import DynamicSearch from "@/components/DynamicSearch";
import DataTableMixin from "@/mixins/DataTableMixin";
import { deleteUseById, review } from "@/api/bill/ResourceUse";
import { tableSataus } from "@/views/bill/mixins/status";
import { downloadExcel } from "@/api/bill/ProjectPlan";

export default {
  name: "ResourceUse",
  mixins: [DataTableMixin, tableSataus],
  components: { DynamicSearch },
  created() {
    // 列表数据初始化
    this.$nextTick(() => {
      this.dataTableInit();
    });
  },
  data() {
    return {
      queryFields: [
        {
          label: "项目名",
          prop: "projectName",
          query: {
            type: "input"
          },
        },
        {
          label: "人员",
          prop: "name",
          query: {
            type: "input"
          },
        }
      ],
      tableHead: [
        {
          label: "单据编号",
          prop: "code",
          query: {
            type: "input"
          },
          align: "center"
        },
        {
          label: "项目号",
          prop: "projectNumber",
          align: "center"
        },
        {
          label: "项目名",
          prop: "projectName",
          query: {
            type: "input"
          },
          align: "center"
        },
        {
          label: "人员",
          prop: "staffEntity",
          align: "center",
          formatter: staffEntity => {
            return staffEntity ? staffEntity.name : ''
          }
        },
        {
          label: "工号",
          prop: "personCode",
          align: "center"
        },
        // {
        //   label: "原占用项目号",
        //   prop: "rawOccupyProjectNum",
        //   align: "center"
        // },
        // {
        //   label: "原申请项目经理",
        //   prop: "rawApplyforPmEntity.name",
        //   align: "center"
        // },
        {
          label: "职级",
          prop: "rank",
          align: "center"
        },
        // {
        //   label: "结算单价",
        //   prop: "staffEntity.settleAccountUnitPrice",
        //   align: "center"
        // },
        {
          label: "单据状态",
          prop: "billState",
          align: "center",
          formatter: state => {
            return this.statusName(state);
          }
        }
      ],
      tableData: []
    };
  },
  methods: {
     // 导出
      downloadExcel() {
        const obj = Object.keys(this._query)
      const query = {projectName: this._query[obj[0]],userName: this._query[obj[1]]}
      // console.log(query)
        downloadExcel('/resourceRorrowing/getOriginalProjectExcel',query,'资源借用')
      },
    // 表格数据接口参数设置
    dataTableBeforeInit() {
      this._url = `/resourceRorrowing/getList`;
      const params = { page: this.page, size: this.offset };
      this._params = Object.assign(params, this._query);
      return true;
    },
    // 删除
    del(id) {
      if (id) {
        this.$refs[id].doClose();
        this.loading = true;
        deleteUseById(id).then(res => {
          if (res.code === 200) {
            this.loading = false;
            this.$notify({
              title: '删除成功',
              type: 'success',
              duration: 2500
            })
            this.$nextTick(() => {
              // console.log(1);
              this.dataTableInit();
            });
          }
        }).catch(() => {
          this.loading = false;
        });
      }
    },
    // 修改
    edit(data) {
      // this.$router.push({ path: "ResourceUse/form", query: { id: data.id} });
      this.$router.push({name: "ResourceUseFrom" ,params: { id: data.id,isEdit: 1 }})
    },
    audit(data) {
      review({ id: data.id,  billState: 3}).then(res => {
        if (res.code === 200) {
          this.$notify({
            title: "操作成功",
            type: "success",
            duration: 2500
          });
          this.dataTableInit()
        }
      })
      this.$refs[`audit${data.id}`].doClose();
    },
    // 4退回 5 反审核
    reject(data, status = 4) {
      review({ id: data.id,  billState: status}).then(res => {
        if (res.code === 200) {
          this.$notify({
            title: "操作成功",
            type: "success",
            duration: 2500
          });
          this.dataTableInit()
        }
      })
      this.$refs[`audit${data.id}`].doClose();
    },
    // 查看
    showById(data) {
      this.$router.push({name: "ResourceUseFrom" ,params: { id: data.id,isEdit: 0 }})
    },
    add() {
       this.$router.push({name: "ResourceUseFrom"})
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
